import { DataAnalystRolePromoSource, InAppAwarenessPromoSource } from './types';

export const getDataAnalystPromoTrackingId = ({
  prefix = 'call-intel:data-analyst-promo',
  source,
  action,
}: {
  prefix?: string;
  source: DataAnalystRolePromoSource;
  action: string;
}) => {
  return `${prefix}:${source}:${action}`;
};

export const getInAppAwarenessBannerTrackingId = ({
  prefix = 'call-intel:in-app-awareness-promo',
  isBeta = false,
  source,
  action,
}: {
  prefix?: string;
  source: InAppAwarenessPromoSource;
  isBeta?: boolean;
  action: string;
}) => {
  return [prefix, isBeta ? 'beta' : '', source, action].filter(Boolean).join(':');
};
